import Vue from 'vue'
import moment from 'moment-timezone'
import router from "./router"

function notifyCommunicationError() {
	Vue.notify({
			group: 'global',
			type: 'error',
			title: 'Error Communicating With Server',
			text: 'There was an error communicating with the server. Please refresh the page after a few seconds and try again.',
			duration: -1,
			max: 1,
	})
}

function fixDate(date) {
	return moment.tz(date.substring(0, date.indexOf(".")), "America/New_York")
}

function useCachedPsychic(state, id) {
	return state.psychic.status === 'DONE' && 
		state.psychic.id === id && 
		moment.duration(moment(new Date()).diff(moment(state.psychic.lastFetched))).asMinutes() < 10
}

//function useCachedReadings(state, start, end, id) {
//  return state.readings.status === 'DONE' &&
//    state.readings.id === id &&
//    !state.readings.customized &&
//    (start === undefined || isNaN(start)) && (end === undefined || isNaN(end)) &&
//    moment.duration(moment(new Date()).diff(moment(state.readings.lastFetched))).asMinutes() < 10
//}

function getBaseApiUri() {
	if (window.location.hostname.includes("circleofstars.com")) {
		return "https://api.circleofstars.com"
	} else if (window.location.hostname.includes("onesun.com")) {
		return "https://api.onesun.com"
	} else {
		return "http://192.168.1.41:3000"
	}
}

const cleanState = {
		debug: true,
		baseApiUri: getBaseApiUri(),
		payStart: new Date(),
		payEnd: new Date(),
		statistics: {
			data: null,
			startDate: null,
			endDate: null,
		},
		allStatistics: {
			data: null,
			startDate: null,
			endDate: null,
		},
		profile: {
			data: [],
		},
		status: {
			data: "B",
		},
		scheduled: {
			data: [],
		},
		psychics: {
			data: [],
			status: 'NEW',
			lastFetched: null
		},
		psychicCustomers: {
			data: []
		},
		psychic: {
			data: {
				userName: null,
				firstName: null,
				lastName: null,
				email: null,
				phone: null,
				ext: null,
				acctStatus: null,
				status: null,
				image: null,
				permissions: null,
				autoEmail: false
			},
			status: 'NEW',
			lastFetched: null
		},
		readings: {
			data: {
				readings: [],
				summary: {}
			},
			status: 'NEW',
			lastFetched: null
		},
		logins: {
			data: [],
			status: 'NEW',
			lastFetched: null
		},
		customers: {
			data: [],
			status: 'NEW',
			lastFetched: null
		},
		customerDetail: {
			data: [],
			status: 'NEW',
			lastFetched: null
		},
		schedule: {
			data: [],
			status: 'NEW',
			lastFetched: null
		},
		statisticsSummary: {
			data: [],
		},
		listings: {
			data: {},
			status: 'NEW',
			lastFetched: null
		},
		approvals: {
			data: []
		}
}

export default {
	state: cleanState,
	getters: {
		async getPhones(state, id) {
			log(state, `getPhones(${id}`)
			try {
				const data = await remoteExec(state, `/psychics/${id}/phones`)
				return data
			} catch (e) {
				log(state, `getPhones failed: ${e}`)
				notifyCommunicationError()
				throw e
			}
		},
		async usernameAvailable(state, username) {
			log(state, `usernameAvailable(${username}`)
			try {
				const data = await remoteExec(state, `/psychics/username_available?username=${username}`)
				return data
			} catch (e) {
				log(state, `usernameAvailable failed: ${e}`)
				notifyCommunicationError()
				throw e
			}
		},
		async phonePinAvailable(state, phone, pin) {
			log(state, `phonePinAvailable(${phone}, ${pin}`)
			try {
				const data = await remoteExec(state, `/psychics/phone_pin_available?phone=${phone}&pin=${pin}`)
				return data
			} catch (e) {
				log(state, `phonePinAvailable failed: ${e}`)
				notifyCommunicationError()
				throw e
			}
		},
		async getContacts(state, id) {
			log(state, `getContacts(${id})`)
			try {
				const data = await remoteExec(state, `/contacts`)
				return data
			} catch (e) {
				log(state, `getContacts failed: ${e}`)
				notifyCommunicationError()
				throw e
			}
		},
		async getCityState(state, postalCode) {
			log(state, `getCityState(${postalCode})`)
			try {
				const data = await remoteExec(state, `/locations/${postalCode}`)
				return data
			} catch (e) {
				log(state, `getCityState failed: ${e}`)
				notifyCommunicationError()
				throw e
			}
		},
		async getEligibleGifts(state, id) {
			log(state, `getEligibleGifts(${id})`)
			try {
				const data = await remoteExec(state, `/psychics/${id}/gifts/eligible`)
				for(let i = 0; i < data.length; i++) {
					data[i].last = fixDate(data[i].last_call)
				}
				return data
			} catch (e) {
				log(state, `getEligibleGifts failed: ${e}`)
				notifyCommunicationError()
				throw e
			}
		},
		async getSentGifts(state, id) {
			log(state, `getSentGifts(${id})`)
			try {
				const data = await remoteExec(state, `/psychics/${id}/gifts`)
				for(let i = 0; i < data.length; i++) {
					data[i].date = fixDate(data[i].sent_date)
				}
				return data
			} catch (e) {
				log(state, `getSentGifts failed: ${e}`)
				notifyCommunicationError()
				throw e
			}
		},
		async getProfile(state, id) {
			log(state, `getProfile(${id})`)
			try {
				const data = await remoteExec(state, `/psychics/${id}/profile`)
				state.profile.data = data
			} catch (e) {
				log(state, `getProfile failed: ${e}`)
				notifyCommunicationError()
				throw e
			}

			return state.profile.data
		},
		async getManagerProfile(state) {
			log(state, `getManagerProfile()`)
			try {
				const data = await remoteExec(state, `/profile`)
				state.profile.data = data
			} catch (e) {
				log(state, `getManagerProfile failed: ${e}`)
				notifyCommunicationError()
				throw e
			}

			return state.profile.data
		},
		async getStatisticsSummary(state, start, end) {
			log(state, `getStatisticsSummary(${start}, ${end})`)

			let uri = `/statistics/summary`
			if (start !== undefined && !isNaN(start) && end !== undefined && !isNaN(end)) {
				uri = `${uri}?start_date=${moment(start).format("YYYY-MM-DD")}&end_date=${moment(end).format("YYYY-MM-DD")}`
			}
			try {
				const data = await remoteExec(state, uri)
				state.statisticsSummary.data = data
			} catch (e) {
				log(state, `getStatisticsSummary failed: ${e}`)
				notifyCommunicationError()
				throw e
			}

			return state.statisticsSummary.data
		},
		async getApprovals(state) {
			log(state, `getApprovals()`)
			try {
				const data = await remoteExec(state, `/approvals`)
				for(let i = 0; i < data.length; i++) {
					data[i].date = fixDate(data[i].max_creation_date)
				}
				state.approvals.data = data
			} catch (e) {
				log(state, `getApprovals failed: ${e}`)
				notifyCommunicationError()
				throw e
			}

			return state.approvals.data
		},
		async getBusyPsychicCount(state) {
			log(state, `getBusyPsychicCount()`)
			try {
				const data = await remoteExec(state, `/psychics/busy`)
				return data
			} catch (e) {
				log(state, `getBusyPsychicCount failed: ${e}`)
				notifyCommunicationError()
				throw e
			}
		},
		async getPsychicCustomers(state, id, start, end) {
			log(state, `getPsychicCustomers(${id}, ${start}, ${end})`)

			let uri = `/psychics/${id}/customers/psychic`
			if (start !== undefined && !isNaN(start) && end !== undefined && !isNaN(end)) {
				uri = `${uri}?start_date=${moment(parseInt(start)).format("YYYY-MM-DD")}&end_date=${moment(parseInt(end)).format("YYYY-MM-DD")}`
			}

			try {
				const data = await remoteExec(state, uri)
					for (let i = 0; i < data.length; i++) {
						data[i].lastReading = fixDate(data[i].last_contact_date)
					}
					state.psychicCustomers.data = data
			} catch (e) {
				log(state, `getPsychicCustomers failed: ${e}`)
				notifyCommunicationError()
				throw e
			}

			return state.psychicCustomers.data
		},
		async getStatistics(state, id) {
			log(state, `getStatistics(${id})`)
			try {
				const data = await remoteExec(state, `/psychics/${id}/statistics`)
				console.log(data)
					for (let i = 0; i < data.length; i++) {
						if(data[i].length > 0) {
							if (Array.isArray(data[i])){
								data[i][0].fromDate = fixDate(data[i][0].period_from)
								data[i][0].toDate = fixDate(data[i][0].period_to)
							}
						}
					}
					state.statistics.data = data
			} catch (e) {
				log(state, `getStatistics failed: ${e}`)
				notifyCommunicationError()
				throw e
			}

			return state.statistics.data
		},
		async getPsychicSearch(state, term) {
			log(state, `getPsychicSearch()`)
			let uri = `/search/${term}`
			let data = []
			try {
				data = await remoteExec(state, uri)
			} catch (e) {
				log(state, `getPsychicSearch failed: ${e}`)
				notifyCommunicationError()
				throw e
			}

			return data
		},
		async getAllStatistics(state, start, end, refresh) {
			if (refresh === undefined) {
				refresh = false
			}
			if (state.allStatistics.data === null || refresh) {
				state.allStatistics.startDate = start
				state.allStatistics.end = end
				log(state, `getAllStatistics()`)
				let uri = `/statistics`
				if (start !== undefined && !isNaN(start) && end !== undefined && !isNaN(end)) {
					uri = `${uri}?start_date=${moment(parseInt(start)).format("YYYY-MM-DD")}&end_date=${moment(parseInt(end)).format("YYYY-MM-DD")}`
				}

				try {
					const data = await remoteExec(state, uri)
					state.allStatistics.data = data
				} catch (e) {
					log(state, `getAllStatistics failed: ${e}`)
					notifyCommunicationError()
					throw e
				}
			}

			return state.allStatistics.data
		},
		async getPsychics(state, start, end) {
			log(state, `getPsychics(${start}, ${end})`)

			let uri = `/psychics`
			if (start !== undefined && !isNaN(start) && end !== undefined && !isNaN(end)) {
				uri = `${uri}?start_date=${moment(parseInt(start)).format("YYYY-MM-DD")}&end_date=${moment(parseInt(end)).format("YYYY-MM-DD")}`
			}
			try {
				const data = await remoteExec(state, uri)
					for (let i = 0; i < data.length; i++) {
						data[i].date = fixDate(data[i].signup_date)
					}
					state.psychics.data = data
			} catch (e) {
				log(state, `getPsychics failed: ${e}`)
				notifyCommunicationError()
				throw e
			}

			return state.psychics.data
		},
		async getPsychic(state, id, refresh) {
			if (useCachedPsychic(state, id) && refresh !== true) {
				return state.psychic.data
			}

			log(state, `getPsychic(${id})`)
			try {
				const data = await remoteExec(state, `/psychics/${id}`)
				state.psychic = Object.assign(state.psychic, {
					data: {
						userName: data["username"],
						firstName: data["first"],
						lastName: data["last"],
						email: data["email"],
						phone: data["phone"],
						ext: data["extension"],
						acctStatus: data["account_status"],
						status: data["status"],
						image: data["image"],
						permissions: data["permissions"],
						autoEmail: data["auto_email"],
						avg_rating: data["avg_rating"],
						requires_approval: data["requires_approval"]
					},
					status: 'DONE',
					id: id,
					lastFetched: Date.now()
				})
			} catch (e) {
				log(state, `getPsychic failed: ${e}`)
				notifyCommunicationError()
				throw e
			}

			return state.psychic.data
		},
		async getStatus(state, id) {
			log(state, `getStatus(${id})`)
			try {
				const data = await remoteExec(state, `/psychics/${id}/status`)
				state.status.data = data[0].code
			} catch (e) {
				log(state, `getStatus failed: ${e}`)
				notifyCommunicationError()
				throw e
			}

			return state.status.data
		},
		async getDupes(state, id) {
			log(state, `getDupes(${id})`)
			let data = []
			try {
				data = await remoteExec(state, `/psychics/${id}/dupes`)
			} catch (e) {
				log(state, `getDupes failed: ${e}`)
				notifyCommunicationError()
				throw e
			}

			return data
		},
		async getScheduled(state, id) {
			log(state, `getScheduled(${id})`)
			try {
				const data = await remoteExec(state, `/psychics/${id}/scheduled_calls`)
				state.scheduled.data = data
			} catch (e) {
				log(state, `getScheduled failed: ${e}`)
				notifyCommunicationError()
				throw e
			}

			return state.scheduled.data
		},
		async authorizePassword(state, uuid) {
			log(state, `authorizePassword(${uuid})`)
			try {
				await remoteExec(state, `/profile/authorize_password/${uuid}`)
			} catch (e) {
				log(state, `authorizePassword failed: ${e}`)
				notifyCommunicationError()
				throw e
			}
		},
		//async getReadings(state, id, start, end, refresh) {
		async getReadings(state, id, start, end) {
			log(state, `getReadings(` + id + `, ` + start + `, ` + end + `)`)
			//if (useCachedReadings(state, start, end, id) && refresh !== true) {
			//  return state.readings.data
			//}

			let uri = `/psychics/${id}/readings`
			if (start !== undefined && !isNaN(start) && end !== undefined && !isNaN(end)) {
				state.readings.customized = true
				uri = `${uri}?start_date=${moment(parseInt(start)).format("YYYY-MM-DD")}&end_date=${moment(parseInt(end)).format("YYYY-MM-DD")}`
			} else {
				state.readings.customized == false
			}

			try {
				const data = await remoteExec(state, uri)
				state.readings = Object.assign(state.readings, {
					data: {
						readings: data.readings.map(d => ({
							connID: d["connection_id"],
							date: fixDate(d["call_date"]),
							custUserName: d["username"],
							type: d["type"],
							mins: d["duration"],
							revenue: d["revenue"] || 0,
							freeMins: d["free_minutes"],
							paidMins: d["paid_minutes"],
							rate: d["rate"],
							result: d["result"],
							rating: d["rating"],
							ratingText: d["rating_text"],
							has_recording: d["has_recording"]
						})),
						summary: {
							totCalls: data.summary.total_calls,
							repCalls: data.summary.repeat_calls,
							freeMins: data.summary.free_minutes,
							repMins: data.summary.repeat_minutes,
							totMins: data.summary.total_minutes,
							repPct: data.summary.repeat_pct,
							missCalls: data.summary.missed_calls,
							alc: data.summary.alc
						},
					},
					id: id,
					status: 'DONE',
					lastFetched: Date.now()
				})
			} catch (e) {
				log(state, `getReadings failed: ${e}`)
				notifyCommunicationError()
				throw e
			}

			return state.readings.data
		},
		async getLogins(state, id, start, end) {
			log(state, `getLogins(${id},${start},${end})`)

			let uri = `/psychics/${id}/logins`
			if (start !== undefined && !isNaN(start) && end !== undefined && !isNaN(end)) {
				uri = `${uri}?start_date=${moment(parseInt(start)).format("YYYY-MM-DD")}&end_date=${moment(parseInt(end)).format("YYYY-MM-DD")}`
			}

			try {
				const data = await remoteExec(state, uri)
				state.logins = Object.assign(state.logins, {
					data: data.map(d => ({
						login: fixDate(d.login_date),
						logout: fixDate(d.logout_date),
						duration: d.duration
					})),
					status: 'DONE',
					lastFetched: Date.now()
				})
			} catch (e) {
				log(state, `error calling GetLogins: ${e}`)
				notifyCommunicationError()
				throw e
			}

			return state.logins.data
		},
		async getListings(state, id) {
			log(state, `getListings(${id})`)
			try {
				const data = await remoteExec(state, `/psychics/${id}/listings`)
				state.listings = Object.assign(state.listings, {
					data: data
				})
			} catch (e) {
				log(state, `getListings failed: ${e}`)
				notifyCommunicationError()
				throw e
			}

			return state.listings.data
		},
		async getCustomers(state, id, start, end) {
			log(state, `getCustomers(${id},${start},${end})`)

			let uri = `/psychics/${id}/customers`
			if (start !== undefined && !isNaN(start) && end !== undefined && !isNaN(end)) {
				state.readings.customized = true
				uri = `${uri}?start_date=${moment(parseInt(start)).format("YYYY-MM-DD")}&end_date=${moment(parseInt(end)).format("YYYY-MM-DD")}`
			} else {
				state.readings.customized == false
			}

			try {
				const data = await remoteExec(state, uri)
				state.customers = Object.assign(state.customers, {
					data: data.map(d => ({
						ID: d["id"],
						userName: d["username"],
						lastReading: fixDate(d["last_call"]),
						readings: d["total_calls"],
						totalMinutes: d["total_minutes"],
						freeMins: d["free_minutes"],
						alc: d["alc"],
					})),
					status: 'DONE',
					lastFetched: Date.now()
				})
			} catch (e) {
				log(state, `getCustomers failed: ${e}`)
				notifyCommunicationError()
				throw e
			}

			return state.customers.data
		},
		async getCustomerDetail(state, id, customer) {
			log(state, `getCustomerDetail(${id}, ${customer})`)
			try {
				const data = await remoteExec(state, `/psychics/${id}/customers/${customer}`)
				state.customerDetail = Object.assign(state.customerDetail, {
					data: data.map(d => ({
						date: fixDate(d["date"]),
						minutes: d["minutes"]
					})),
					status: 'DONE',
					lastFetched: Date.now()
				})
			} catch (e) {
				log(state, `getCustomerDetail failed: ${e}`)
				notifyCommunicationError()
				throw e
			}

			return state.customerDetail.data
		},
		async getSchedule(state, id) {
			log(state, `getSchedule(${id})`)
			try {
				const data = await remoteExec(state, `/psychics/${id}/schedule`)
				state.schedule = Object.assign(state.schedule, {
					data: data.map(d => ({
						day: d.day,
						number: d.number,
						from: fixDate(d.from),
						to: fixDate(d.to),
						status: d.status
					})),
					status: 'DONE',
					lastFetched: Date.now()
				})
			} catch (e) {
				log(state, `getSchedule failed: ${e}`)
				notifyCommunicationError()
				throw e
			}

			return state.schedule.data
		}
	},
	setters: {
		async createPsychic(state, psychic) {
			log(state, `createPsychic(${psychic})`)
			try {
				await remoteExec(state, `/psychics`, { method: 'POST', body: JSON.stringify({psychic: psychic}) })
			} catch (e) {
				log(state, `createPsychic failed: ${e}`)
				notifyCommunicationError()
				throw e
			}
		},
		async updateProfile(state, profile) {
			log(state, `updateProfile(${profile})`)
			try {
				await remoteExec(state, `/psychics/${profile.id}/profile`, { method: 'PUT', body: JSON.stringify({profile: profile}) })
			} catch (e) {
				log(state, `updateProfile failed: ${e}`)
				notifyCommunicationError()
				throw e
			}
		},
		async updateManagerProfile(state, profile) {
			log(state, `updateManagerProfile(${profile})`)
			try {
				await remoteExec(state, `/profile`, { method: 'PUT', body: JSON.stringify({profile: profile}) })
			} catch (e) {
				log(state, `updateManagerProfile failed: ${e}`)
				notifyCommunicationError()
				throw e
			}
		},
		async setStatus(state, id, status) {
			log(state, `setStatus(${id}, ${status})`)
			try {
				await remoteExec(state, `/psychics/${id}/status`, { method: 'POST', body: JSON.stringify({code: status}) })
			} catch (e) {
				log(state, `setStatus failed: ${e}`)
				notifyCommunicationError()
				throw e
			}
		},
		async setAcctStatus(state, id, status) {
			log(state, `setAcctStatus(${id}, ${status})`)
			try {
				await remoteExec(state, `/psychics/${id}/acct_status`, { method: 'PUT', body: JSON.stringify({acctStatus: status}) })
			} catch (e) {
				log(state, `setAcctStatus failed: ${e}`)
				notifyCommunicationError()
				throw e
			}
		},
		async setPermissions(state, id, permissions) {
			log(state, `setPermissions(${id}, ${permissions})`)
			try {
				await remoteExec(state, `/psychics/${id}/permissions`, { method: 'PUT', body: JSON.stringify({permissions: permissions}) })
			} catch (e) {
				log(state, `setPermissions failed: ${e}`)
				notifyCommunicationError()
				throw e
			}
		},
		async setAutoEmail(state, id, autoEmail) {
			log(state, `setAutoEmail(${id}, ${autoEmail})`)
			try {
				await remoteExec(state, `/psychics/${id}/auto_email`, { method: 'PUT', body: JSON.stringify({autoEmail: autoEmail}) })
			} catch (e) {
				log(state, `setAutoEmail failed: ${e}`)
				notifyCommunicationError()
				throw e
			}
		},
		async sendGifts(state, id, gifts) {
			log(state, `sendGifts(${id}, ${gifts})`)
			try {
				await remoteExec(state, `/psychics/${id}/gifts`, { method: 'POST', body: JSON.stringify(gifts) })
			} catch (e) {
				log(state, `sendGifts failed: ${e}`)
				notifyCommunicationError()
				throw e
			}
		},
		async updateSchedule(state, id, schedule) {
			log(state, `updateSchedule(${id}, ${schedule})`)
			let postSchedule = []
			for(let i = 0; i < schedule.length; i++) {
				postSchedule.push({
					day: schedule[i].day,
					number: schedule[i].number,
					status: schedule[i].status,
					from: moment.tz(schedule[i].from, "America/New_York").format("YYYY-MM-DD[T]HH:mm:ss[.000Z]"),
					to: moment.tz(schedule[i].to, "America/New_York").format("YYYY-MM-DD[T]HH:mm:ss[.000Z]")
				})
			}
			try {
				await remoteExec(state, `/psychics/${id}/schedule`, { method: 'POST', body: JSON.stringify({schedule: postSchedule})})
			} catch (e) {
				log(state, `updateSchedule failed: ${e}`)
				notifyCommunicationError()
				throw e
			}
		},
		async reportProblem(state, id, problem) {
			log(state, `reportProblem(${id}, ${problem})`)
			try {
				await remoteExec(state, `/psychics/${id}/problem`, { method: 'POST', body: JSON.stringify(problem) })
			} catch (e) {
				log(state, `reportProblem failed: ${e}`)
				notifyCommunicationError()
				throw e
			}
		},
		async authenticate(state, username, password) {
			log(state, `authenticate(${username}, ${password})`)
			try {
				const data = await remoteExec(state, `/sessions`, { method: 'POST', body: JSON.stringify({username, password}) })
				localStorage.setItem("user", JSON.stringify(data))
				state.id = data.user_id

				const pay_day = moment().tz("America/New_York").day(JSON.parse(localStorage.getItem("user")).pay_day).add(-1, "days")
				const today = moment().tz("America/New_York")

				if (pay_day < today) {
					if (pay_day.format("MM/DD/YYYY") == today.format("MM/DD/YYYY")) {
						state.payStart = pay_day.valueOf().toString()
						state.payEnd = pay_day.add(6, "days").valueOf().toString()
					} else {
						state.payStart = pay_day.add(1, "days").valueOf().toString()
						state.payEnd = pay_day.add(6, "days").valueOf().toString()
					}
				} else {
					state.payStart = moment(pay_day).add(-6, "days").valueOf().toString()
					state.payEnd = pay_day.valueOf().toString()
				}
			} catch (e) {
				if (!(e.response && e.response === 401)) {
					log(state, `authenticate failed: ${e}`)
					notifyCommunicationError()
				}

				throw e
			}
		},
		async saveListing(state, id, listing) {
			log(state, `saveListing(${id}, ${listing})`)
			const postListing = {
				sales_pitch: listing.sales_pitch,
				body: listing.body,
				categories: listing.categories.join(",")
			}
			try {
				await remoteExec(state, `/psychics/${id}/listings`, { method: 'POST', body: JSON.stringify({listing: postListing}) })
			} catch (e) {
				log(state, `saveListing failed: ${e}`)
				notifyCommunicationError()
				throw e
			}
		},
		async createContact(state, contact) {
			log(state, `createContact(${contact})`)
			try {
				await remoteExec(state, `/contacts`, { method: 'POST', body: JSON.stringify({contact: contact}) })
			} catch (e) {
				log(state, `createContact failed: ${e}`)
				notifyCommunicationError()
				throw e
			}
		},
		async deleteContact(state, id) {
			log(state, `deleteContact(${id})`)
			try {
				await remoteExec(state, `/contacts/${id}`, { method: 'DELETE' })
			} catch (e) {
				log(state, `deleteContact failed: ${e}`)
				notifyCommunicationError()
				throw e
			}
		},
		async approveListing(state, id) {
			log(state, `approveListing(${id})`)
			try {
				await remoteExec(state, `/psychics/${id}/listings/approve`, { method: 'POST' })
			} catch (e) {
				log(state, `approveListing failed: ${e}`)
				notifyCommunicationError()
				throw e
			}
		},
		async rejectListing(state, id) {
			log(state, `rejectListing(${id})`)
			try {
				await remoteExec(state, `/psychics/${id}/listings/reject`, { method: 'POST' })
			} catch (e) {
				log(state, `rejectListing failed: ${e}`)
				notifyCommunicationError()
				throw e
			}
		},
		async deleteRejectedListing(state, id) {
			log(state, `deleteRejectedListing(${id})`)
			try {
				await remoteExec(state, `/psychics/${id}/listings/delete_rejected`, { method: 'POST' })
			} catch (e) {
				log(state, `deleteRejectedListing failed: ${e}`)
				notifyCommunicationError()
				throw e
			}
		},
		async updatePhones(state, id, phones) {
			log(state, `updatePhones()`)
			try {
				await remoteExec(state, `/psychics/${id}/phones`, { method: 'POST', body: JSON.stringify({phone: phones})})
			} catch (e) {
				log(state, `updatePhones failed: ${e}`)
				notifyCommunicationError()
				throw e
			}
		},
		async updatePassword(state, password) {
			log(state, `updatePassword()`)
			try {
				await remoteExec(state, `/profile/password`, { method: 'PUT', body: JSON.stringify(password)})
			} catch (e) {
				log(state, `updatePassword failed: ${e}`)
				if (e.response != 422) {
					notifyCommunicationError()
				}
				throw e
			}
		},
		async updatePasswordUnchecked(state, password) {
			log(state, `updatePasswordUnchecked()`)
			try {
				await remoteExec(state, `/profile/password_unchecked`, { method: 'PUT', body: JSON.stringify(password)})
			} catch (e) {
				log(state, `updatePasswordUnchecked failed: ${e}`)
				notifyCommunicationError()
				throw e
			}
		},
		async updateAgentPassword(state, password) {
			log(state, `updateAgentPassword()`)
			try {
				await remoteExec(state, `/profile/agent_password`, { method: 'PUT', body: JSON.stringify(password)})
			} catch (e) {
				log(state, `updateAgentPassword failed: ${e}`)
				if (e.response != 422) {
					notifyCommunicationError()
				}
				throw e
			}
		},
		async setPhonePreferred(state, id, phone_id) {
			log(state, `setPhonePreferred(${id}, ${phone_id})`)
			try {
				await remoteExec(state, `/psychics/${id}/phones/${phone_id}/set_preferred`, { method: 'POST' })
			} catch (e) {
				log(state, `setPhonePreferred failed: ${e}`)
				notifyCommunicationError()
				throw e
			}
		},
		async approveProfile(state, id) {
			log(state, `approveProfile(${id}`)
			try {
				await remoteExec(state, `/profile/${id}/approve`, { method: 'POST' })
			} catch (e) {
				log(state, `approveProfile failed: ${e}`)
				notifyCommunicationError()
				throw e
			}
		},
		async rejectProfile(state, id) {
			log(state, `rejectProfile(${id}`)
			try {
				await remoteExec(state, `/profile/${id}/reject`, { method: 'POST' })
			} catch (e) {
				log(state, `rejectProfile failed: ${e}`)
				notifyCommunicationError()
				throw e
			}
		},
		async forgotPassword(state, email) {
			log(state, `forgotPassword(${email}`)
			try {
				await remoteExec(state, `/profile/forgot_password`, { method: 'POST', body: JSON.stringify({email: email}) })
			} catch (e) {
				log(state, `forgotPassword failed: ${e}`)
				notifyCommunicationError()
				throw e
			}
		},
		async logOut(state) {
			log(state, `logOut()`)
			try {
				await remoteExec(state, `/sessions/0`, { method: 'DELETE' })
				this.state = cleanState
			} catch (e) {
				log(state, `logOut failed: ${e}`)
				notifyCommunicationError()
				throw e
			}
		},
		clearAllData(data) {
			data.state = cleanState
		}
	}
}

async function remoteExec(state, uri, options) {
	const defaultOptions = {
		method: 'GET',
		credentials: 'include',
		headers: {
			'Content-Type': 'application/json'
		}
	}

	try {
		const response = await fetch(`${state.baseApiUri}${uri}`, Object.assign(defaultOptions, options)) 

		if (!response.ok) {
			throw { response: response.status } 
		} else {
			if (response.status !== 204) {
				const data = await response.json()
				return data
			}
		}
	} catch(e) {
		if (e.response) {
			if (e.response === 401 || e.response === 403) {
				router.push("/login")
			}
			throw e
		} else {
				notifyCommunicationError()
				throw e
		}
	}
}

function log(state, message) {
	if (state.debug) {
		console.log(message)
	}
}
